
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.97 2c.757 0 1.153.876.696 1.443l-.067.074-3.371 3.372 3.37 3.371c.537.536.196 1.435-.527 1.512l-.1.006H5.414v5.333a.889.889 0 01-.785.883L4.526 18a.89.89 0 01-.883-.785l-.006-.104V2.89a.889.889 0 01.785-.883L4.526 2H16.97z","fill":"#FFCC18"}})])
          )
        }
      }
    